import { Button, ButtonGroup, Card, Dialog, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import Grid from '@mui/system/Unstable_Grid/Grid';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { MultiSelect } from './multivalue';
import { Seo } from 'src/components/seo';
import { useSettings } from 'src/hooks/use-settings';
import MonthEndAlertTable from './month-end-alert-table';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMonthlyCloseOutAlert,
  resetUploadSignFileAction,
} from 'src/redux/actions/monthlyCloseOutAction';
import moment from 'moment';
import { useNavigate } from 'react-router';
import SignatureAlertDocument from './SignatureAlertDocument';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';

type Props = {};
const months = [
  { value: 'JANUARY', label: 'January' },
  { value: 'FEBRUARY', label: 'February' },
  { value: 'MARCH', label: 'March' },
  { value: 'APRIL', label: 'April' },
  { value: 'MAY', label: 'May' },
  { value: 'JUNE', label: 'June' },
  { value: 'JULY', label: 'July' },
  { value: 'AUGUST', label: 'August' },
  { value: 'SEPTEMBER', label: 'September' },
  { value: 'OCTOBER', label: 'October' },
  { value: 'NOVEMBER', label: 'November' },
  { value: 'DECEMBER', label: 'December' },
];

const years = [
  // { value: '2025', label: '2025' },
  { value: '2024', label: '2024' },
  { value: '2023', label: '2023' },
  { value: '2022', label: '2022' },
  { value: '2021', label: '2021' },
  { value: '2020', label: '2020' },
  { value: '2019', label: '2019' },
  { value: '2018', label: '2018' },
  { value: '2017', label: '2017' },
  { value: '2016', label: '2016' },
  { value: '2015', label: '2015' },
  { value: '2014', label: '2014' },
  { value: '2013', label: '2013' },
  { value: '2012', label: '2012' },
  { value: '2011', label: '2011' },
  { value: '2010', label: '2010' },
  { value: '2009', label: '2009' },
  { value: '2008', label: '2008' },
  { value: '2007', label: '2007' },
  { value: '2006', label: '2006' },
  { value: '2005', label: '2005' },
  { value: '2004', label: '2004' },
  { value: '2003', label: '2003' },
  { value: '2002', label: '2002' },
  { value: '2001', label: '2001' },
  { value: '2000', label: '2000' },
];

function getFirstDateOfMonth(monthName: any, year: any) {
  if (!monthName) return;
  const months: any = {
    JANUARY: 0,
    FEBRUARY: 1,
    MARCH: 2,
    APRIL: 3,
    MAY: 4,
    JUNE: 5,
    JULY: 6,
    AUGUST: 7,
    SEPTEMBER: 8,
    OCTOBER: 9,
    NOVEMBER: 10,
    DECEMBER: 11,
  };

  const monthIndex = months[monthName?.toUpperCase()];
  if (monthIndex === undefined) {
    throw new Error('Invalid month name');
  }

  return new Date(year, monthIndex, 1);
}

const MonthlyCloseoutAlert = (props: Props) => {
  const monthCloseOutResponse = useSelector((state: any) => state.monthlyCloseOutAlertReducer);
  const settings = useSettings();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  interface ViewOption {
    label: string;
    value: string;
  }
  const viewOptions: ViewOption[] = [
    {
      label: 'Weekly',
      value: 'WEEKLY',
    },
    {
      label: 'Monthly',
      value: 'MONTHLY',
    },
  ];

  const [activeButton, setActiveButton] = useState('WEEKLY');
  const handleViewChange = (activeButtonName: string) => {
    const newDate = new Date();
    dispatch(
      getMonthlyCloseOutAlert({
        param: {
          currentDate: moment(newDate).format('YYYY-MM-DD'),
          division: activeButtonName,
        },
      })
    );
    setSelectMonth([]);
    setSelectYear([]);
    setActiveButton(activeButtonName);
  };

  const [selectMonth, setSelectMonth] = useState<any>([]);
  const [selectYear, setSelectYear] = useState<any>([]);
  const handleSelectMonth = useCallback((values: any): void => {
    const lastElement = values?.pop();
    const foundObject: any = months?.find((obj: any) => obj?.value === lastElement);

    if (foundObject) {
      setSelectMonth([foundObject?.value]);
    } else {
      setSelectMonth([]);
    }
  }, []);
  const handleSelectYear = useCallback((values: any): void => {
    const lastElement = values?.pop();
    const foundObject: any = years?.find((obj: any) => obj?.value === lastElement);

    if (foundObject) {
      setSelectYear([foundObject?.value]);
    } else {
      setSelectYear([]);
    }
  }, []);

  useEffect(() => {
    const newDate = new Date();
    dispatch(
      getMonthlyCloseOutAlert({
        param: {
          currentDate: moment(newDate).format('YYYY-MM-DD'),
          division: 'WEEKLY',
        },
      })
    );
  }, []);

  useEffect(() => {
    if (!!selectMonth[0] && !selectYear[0]) {
      const currentDate = new Date();
      const selectedNewDate = getFirstDateOfMonth(selectMonth[0], currentDate.getFullYear());
      dispatch(
        getMonthlyCloseOutAlert({
          param: {
            currentDate:
              selectedNewDate?.getMonth() == currentDate?.getMonth()
                ? moment(currentDate).format('YYYY-MM-DD')
                : moment(selectedNewDate).format('YYYY-MM-DD'),
            division: 'WEEKLY',
          },
        })
      );
      return;
    }
    if (!!selectMonth[0] && !!selectYear[0]) {
      const selectedNewDate = getFirstDateOfMonth(selectMonth[0], selectYear[0]);
      dispatch(
        getMonthlyCloseOutAlert({
          param: {
            currentDate: moment(selectedNewDate).format('YYYY-MM-DD'),
            division: 'WEEKLY',
          },
        })
      );
      return;
    }
    if (!selectMonth[0] && !!selectYear[0]) {
      const fullDateByYear = new Date(selectYear[0], 0, 1);

      dispatch(
        getMonthlyCloseOutAlert({
          param: {
            currentDate: moment(fullDateByYear).format('YYYY-MM-DD'),
            division: 'MONTHLY',
          },
        })
      );
      return;
    }
  }, [selectMonth, selectYear]);

  const handleNavigateToMonthEndAlert = (dates: any) => {
    navigate('/monthly-closeout-alerts/month-day-alert', { state: dates });
  };

  const [open, setOpen] = useState(false);
  const [signData, setSignData] = useState('');

  const handleClickOpen = (data: any) => {
    setSignData(data);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [message, setMessage] = useState('');
  const uploadSignatureFile = useSelector((state: any) => state.uploadSignatureFileReducer);

  useEffect(() => {
    if (!uploadSignatureFile?.getStatus && uploadSignatureFile?.response === null) return;
    if (!uploadSignatureFile?.getStatus && uploadSignatureFile?.response !== null) {
      setOpen(false);
      setMessage(uploadSignatureFile?.response?.message);
      setTimeout(() => {
        dispatch(resetUploadSignFileAction());
        setMessage('');
      }, 2000);
      return;
    }
    setOpen(false);
    setMessage(uploadSignatureFile?.response?.message);
    const newDate = new Date();
    dispatch(
      getMonthlyCloseOutAlert({
        param: {
          currentDate: moment(newDate).format('YYYY-MM-DD'),
          division: activeButton,
        },
      })
    );
    setTimeout(() => {
      dispatch(resetUploadSignFileAction());
      setMessage('');
    }, 2000);
  }, [uploadSignatureFile]);

  return (
    <>
      <Seo title="Restore-Insights: Monthly closeout alerts" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // py: 8,
          py: 3,
        }}
      >
        <Container maxWidth={settings.stretch ? false : 'xl'}>
          <Grid
            container
            disableEqualOverflow
            spacing={{
              xs: 3,
              lg: 5,
            }}
          >
            <Grid xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                spacing={4}
              >
                <Typography variant="h4">Closeout Alerts</Typography>
              </Stack>
            </Grid>

            <Grid
              xs={12}
              md={12}
            >
              <ButtonGroup
                variant="contained"
                sx={{
                  border: '1px solid rgba(99, 102, 241, 0.50)',
                  borderRadius: '12px',
                  height: '36px',
                }}
                disabled={monthCloseOutResponse?.loading}
              >
                <Button
                  onClick={() => handleViewChange(viewOptions[0].value)}
                  sx={{
                    color: '#6366F1',
                    background: activeButton === viewOptions[0].value ? '#EBEEFE' : '#FFFFFF',
                    '&:hover': {
                      background: 'transparent',
                    },
                  }}
                >
                  Weekly
                </Button>
                <Button
                  onClick={() => handleViewChange(viewOptions[1].value)}
                  sx={{
                    color: '#6366F1',
                    background: activeButton === viewOptions[1].value ? '#EBEEFE' : '#FFFFFF',
                    '&:hover': {
                      background: 'transparent',
                    },
                  }}
                >
                  Monthly
                </Button>
              </ButtonGroup>
            </Grid>
            <Grid
              xs={12}
              md={12}
            >
              <Card sx={{ padding: '2rem' }}>
                <Stack
                  gap="1rem"
                  sx={{ padding: '0 1rem 1rem 1rem' }}
                  flexDirection="row"
                >
                  {activeButton !== 'MONTHLY' && (
                    <MultiSelect
                      label="Months"
                      onChange={handleSelectMonth}
                      options={months}
                      value={selectMonth}
                    />
                  )}

                  <MultiSelect
                    label="Years"
                    onChange={handleSelectYear}
                    options={years}
                    value={selectYear}
                  />
                </Stack>
                <Stack gap="1rem">
                  <MonthEndAlertTable
                    item={monthCloseOutResponse?.response?.data}
                    handleNavigateToMonthEndAlert={handleNavigateToMonthEndAlert}
                    handleClickOpen={handleClickOpen}
                  />
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ p: 2 }}
      >
        <SignatureAlertDocument
          handleClose={handleClose}
          signData={signData}
        />
      </Dialog>
      {message !== '' && uploadSignatureFile?.response !== null && (
        <SimpleSnackbar
          message={message}
          isError={!uploadSignatureFile?.getStatus}
        />
      )}
    </>
  );
};

export default MonthlyCloseoutAlert;
